module.exports = __webpack_public_path__ + "img/w-profile-setting.4b4b35d0.svg";